import { get } from '~/api'

const MaintenanceEndpoints = {
  MaintenanceStatus: 'maintenance_status',
}

const getMaintenanceStatus = async (): Promise<{ maintenance: boolean }> => {
  const response = await get(MaintenanceEndpoints.MaintenanceStatus)
  return response as { maintenance: boolean }
}

export { getMaintenanceStatus }
